export const WRONG_PASSWORD = "auth/wrong-password";
export const USER_NOT_FOUND = "auth/user-not-found"
export const EMAIL_ALREADY_IN_USE = "auth/email-already-in-use";